import { render } from "./BaseCard.vue?vue&type=template&id=6dc73b3d&scoped=true&ts=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=6dc73b3d&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc73b3d"]])

export default __exports__